import React, { useEffect, useMemo } from 'react';
import { logPageView } from '../../services/CourseService/CourseService';
import LessonScormWindow from '../LessonScormWindow/LessonScormWindow';
import LessonScormPopup from '../LessonScormPopup/LessonScormPopup';

const Lesson = ( { courseOptions, course } ) => {
    // Get learning object
    const learningObject = useMemo( () => {
        return course.learningObjects.find( i => i.id === courseOptions.lessonId );
    }, [ courseOptions ] );

    // Get the lesson format
    const lessonFormat = useMemo( () => {
        if ( !learningObject ) { 
            return undefined;
        }

        const mimeType = learningObject.content.mimetype;
        const format = mimeType.startsWith( 'video' ) ? 'video' : 'scorm';
        
        if ( courseOptions.maximize ) {
            return `${ format }-popup`;
        } else {
            return `${ format }-window`;
        }
    }, [ learningObject ] );

    // Log the page view
    useEffect( () => {
        if ( learningObject && lessonFormat ) {
            const variables = {
                pageUrl: window.location.href,
                pageType: 'scorm-player',
            };

            logPageView( courseOptions.token, variables );
        }
    }, [ learningObject, lessonFormat ] );

    return (
        <div>
            { lessonFormat === 'scorm-popup' &&
                <LessonScormPopup 
                    courseOptions={ courseOptions }
                    course={ course }
                    learningObject={ learningObject }
                />
            }

            { lessonFormat === 'scorm-window' &&
                <LessonScormWindow 
                    courseOptions={ courseOptions }
                    course={ course }
                    learningObject={ learningObject }
                />
            }
        </div>
    );
};

export default Lesson;